import { render, staticRenderFns } from "./TicketIndex.vue?vue&type=template&id=75dda373&scoped=true&"
import script from "./TicketIndex.vue?vue&type=script&lang=js&"
export * from "./TicketIndex.vue?vue&type=script&lang=js&"
import style0 from "./TicketIndex.vue?vue&type=style&index=0&id=75dda373&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75dda373",
  null
  
)

export default component.exports